type IconProps = {
  stroke?: string
}

export function DashboardIcon({ stroke }: IconProps) {
  return (
    <svg
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M8.4 3H4.6C4.03995 3 3.75992 3 3.54601 3.10899C3.35785 3.20487 3.20487 3.35785 3.10899 3.54601C3 3.75992 3 4.03995 3 4.6V8.4C3 8.96005 3 9.24008 3.10899 9.45399C3.20487 9.64215 3.35785 9.79513 3.54601 9.89101C3.75992 10 4.03995 10 4.6 10H8.4C8.96005 10 9.24008 10 9.45399 9.89101C9.64215 9.79513 9.79513 9.64215 9.89101 9.45399C10 9.24008 10 8.96005 10 8.4V4.6C10 4.03995 10 3.75992 9.89101 3.54601C9.79513 3.35785 9.64215 3.20487 9.45399 3.10899C9.24008 3 8.96005 3 8.4 3Z"
        stroke={stroke ? stroke : '#667085'}
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M19.4 3H15.6C15.0399 3 14.7599 3 14.546 3.10899C14.3578 3.20487 14.2049 3.35785 14.109 3.54601C14 3.75992 14 4.03995 14 4.6V8.4C14 8.96005 14 9.24008 14.109 9.45399C14.2049 9.64215 14.3578 9.79513 14.546 9.89101C14.7599 10 15.0399 10 15.6 10H19.4C19.9601 10 20.2401 10 20.454 9.89101C20.6422 9.79513 20.7951 9.64215 20.891 9.45399C21 9.24008 21 8.96005 21 8.4V4.6C21 4.03995 21 3.75992 20.891 3.54601C20.7951 3.35785 20.6422 3.20487 20.454 3.10899C20.2401 3 19.9601 3 19.4 3Z"
        stroke={stroke ? stroke : '#667085'}
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M19.4 14H15.6C15.0399 14 14.7599 14 14.546 14.109C14.3578 14.2049 14.2049 14.3578 14.109 14.546C14 14.7599 14 15.0399 14 15.6V19.4C14 19.9601 14 20.2401 14.109 20.454C14.2049 20.6422 14.3578 20.7951 14.546 20.891C14.7599 21 15.0399 21 15.6 21H19.4C19.9601 21 20.2401 21 20.454 20.891C20.6422 20.7951 20.7951 20.6422 20.891 20.454C21 20.2401 21 19.9601 21 19.4V15.6C21 15.0399 21 14.7599 20.891 14.546C20.7951 14.3578 20.6422 14.2049 20.454 14.109C20.2401 14 19.9601 14 19.4 14Z"
        stroke={stroke ? stroke : '#667085'}
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M8.4 14H4.6C4.03995 14 3.75992 14 3.54601 14.109C3.35785 14.2049 3.20487 14.3578 3.10899 14.546C3 14.7599 3 15.0399 3 15.6V19.4C3 19.9601 3 20.2401 3.10899 20.454C3.20487 20.6422 3.35785 20.7951 3.54601 20.891C3.75992 21 4.03995 21 4.6 21H8.4C8.96005 21 9.24008 21 9.45399 20.891C9.64215 20.7951 9.79513 20.6422 9.89101 20.454C10 20.2401 10 19.9601 10 19.4V15.6C10 15.0399 10 14.7599 9.89101 14.546C9.79513 14.3578 9.64215 14.2049 9.45399 14.109C9.24008 14 8.96005 14 8.4 14Z"
        stroke={stroke ? stroke : '#667085'}
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  )
}

export function DashboardSmallIcon({ stroke }: IconProps) {
  return (
    <svg
      width="48"
      height="48"
      viewBox="0 0 48 48"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <rect width="48" height="48" rx="6" fill="none" />
      <path
        d="M20.4 15H16.6C16.0399 15 15.7599 15 15.546 15.109C15.3578 15.2049 15.2049 15.3578 15.109 15.546C15 15.7599 15 16.0399 15 16.6V20.4C15 20.9601 15 21.2401 15.109 21.454C15.2049 21.6422 15.3578 21.7951 15.546 21.891C15.7599 22 16.0399 22 16.6 22H20.4C20.9601 22 21.2401 22 21.454 21.891C21.6422 21.7951 21.7951 21.6422 21.891 21.454C22 21.2401 22 20.9601 22 20.4V16.6C22 16.0399 22 15.7599 21.891 15.546C21.7951 15.3578 21.6422 15.2049 21.454 15.109C21.2401 15 20.9601 15 20.4 15Z"
        stroke={stroke ? stroke : '#667085'}
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M31.4 15H27.6C27.0399 15 26.7599 15 26.546 15.109C26.3578 15.2049 26.2049 15.3578 26.109 15.546C26 15.7599 26 16.0399 26 16.6V20.4C26 20.9601 26 21.2401 26.109 21.454C26.2049 21.6422 26.3578 21.7951 26.546 21.891C26.7599 22 27.0399 22 27.6 22H31.4C31.9601 22 32.2401 22 32.454 21.891C32.6422 21.7951 32.7951 21.6422 32.891 21.454C33 21.2401 33 20.9601 33 20.4V16.6C33 16.0399 33 15.7599 32.891 15.546C32.7951 15.3578 32.6422 15.2049 32.454 15.109C32.2401 15 31.9601 15 31.4 15Z"
        stroke={stroke ? stroke : '#667085'}
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M31.4 26H27.6C27.0399 26 26.7599 26 26.546 26.109C26.3578 26.2049 26.2049 26.3578 26.109 26.546C26 26.7599 26 27.0399 26 27.6V31.4C26 31.9601 26 32.2401 26.109 32.454C26.2049 32.6422 26.3578 32.7951 26.546 32.891C26.7599 33 27.0399 33 27.6 33H31.4C31.9601 33 32.2401 33 32.454 32.891C32.6422 32.7951 32.7951 32.6422 32.891 32.454C33 32.2401 33 31.9601 33 31.4V27.6C33 27.0399 33 26.7599 32.891 26.546C32.7951 26.3578 32.6422 26.2049 32.454 26.109C32.2401 26 31.9601 26 31.4 26Z"
        stroke={stroke ? stroke : '#667085'}
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M20.4 26H16.6C16.0399 26 15.7599 26 15.546 26.109C15.3578 26.2049 15.2049 26.3578 15.109 26.546C15 26.7599 15 27.0399 15 27.6V31.4C15 31.9601 15 32.2401 15.109 32.454C15.2049 32.6422 15.3578 32.7951 15.546 32.891C15.7599 33 16.0399 33 16.6 33H20.4C20.9601 33 21.2401 33 21.454 32.891C21.6422 32.7951 21.7951 32.6422 21.891 32.454C22 32.2401 22 31.9601 22 31.4V27.6C22 27.0399 22 26.7599 21.891 26.546C21.7951 26.3578 21.6422 26.2049 21.454 26.109C21.2401 26 20.9601 26 20.4 26Z"
        stroke={stroke ? stroke : '#667085'}
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  )
}

export function ProductIcon({ stroke }: IconProps) {
  return (
    <svg
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M20.5 7.27777L12 12M12 12L3.49997 7.27777M12 12L12 21.5M21 16.0586V7.94147C21 7.59883 21 7.4275 20.9495 7.27471C20.9049 7.13953 20.8318 7.01545 20.7354 6.91076C20.6263 6.79242 20.4766 6.70922 20.177 6.54282L12.777 2.43171C12.4934 2.27415 12.3516 2.19537 12.2015 2.16448C12.0685 2.13715 11.9315 2.13715 11.7986 2.16448C11.6484 2.19537 11.5066 2.27415 11.223 2.43171L3.82297 6.54282C3.52345 6.70922 3.37369 6.79242 3.26463 6.91076C3.16816 7.01545 3.09515 7.13953 3.05048 7.27471C3 7.42751 3 7.59883 3 7.94147V16.0586C3 16.4012 3 16.5725 3.05048 16.7253C3.09515 16.8605 3.16816 16.9846 3.26463 17.0893C3.37369 17.2076 3.52345 17.2908 3.82297 17.4572L11.223 21.5683C11.5066 21.7259 11.6484 21.8047 11.7986 21.8356C11.9315 21.8629 12.0685 21.8629 12.2015 21.8356C12.3516 21.8047 12.4934 21.7259 12.777 21.5683L20.177 17.4572C20.4766 17.2908 20.6263 17.2076 20.7354 17.0893C20.8318 16.9846 20.9049 16.8605 20.9495 16.7253C21 16.5725 21 16.4012 21 16.0586Z"
        stroke={stroke ? stroke : '#667085'}
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  )
}

export function ProductSmallIcon({ stroke }: IconProps) {
  return (
    <svg
      width="48"
      height="48"
      viewBox="0 0 48 48"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <rect width="48" height="48" rx="6" fill="none" />
      <path
        d="M32.5 19.2778L24 24M24 24L15.5 19.2778M24 24L24 33.5M33 28.0586V19.9415C33 19.5988 33 19.4275 32.9495 19.2747C32.9049 19.1395 32.8318 19.0154 32.7354 18.9108C32.6263 18.7924 32.4766 18.7092 32.177 18.5428L24.777 14.4317C24.4934 14.2741 24.3516 14.1954 24.2015 14.1645C24.0685 14.1371 23.9315 14.1371 23.7986 14.1645C23.6484 14.1954 23.5066 14.2741 23.223 14.4317L15.823 18.5428C15.5234 18.7092 15.3737 18.7924 15.2646 18.9108C15.1682 19.0154 15.0951 19.1395 15.0505 19.2747C15 19.4275 15 19.5988 15 19.9415V28.0586C15 28.4012 15 28.5725 15.0505 28.7253C15.0951 28.8605 15.1682 28.9846 15.2646 29.0893C15.3737 29.2076 15.5234 29.2908 15.823 29.4572L23.223 33.5683C23.5066 33.7259 23.6484 33.8047 23.7986 33.8356C23.9315 33.8629 24.0685 33.8629 24.2015 33.8356C24.3516 33.8047 24.4934 33.7259 24.777 33.5683L32.177 29.4572C32.4766 29.2908 32.6263 29.2076 32.7354 29.0893C32.8318 28.9846 32.9049 28.8605 32.9495 28.7253C33 28.5725 33 28.4012 33 28.0586Z"
        stroke={stroke ? stroke : '#667085'}
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  )
}

export function DynamicPricingIcon({ stroke }: IconProps) {
  return (
    <svg
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M22 7L14.1314 14.8686C13.7354 15.2646 13.5373 15.4627 13.309 15.5368C13.1082 15.6021 12.8918 15.6021 12.691 15.5368C12.4627 15.4627 12.2646 15.2646 11.8686 14.8686L9.13137 12.1314C8.73535 11.7354 8.53735 11.5373 8.30902 11.4632C8.10817 11.3979 7.89183 11.3979 7.69098 11.4632C7.46265 11.5373 7.26465 11.7354 6.86863 12.1314L2 17M22 7H15M22 7V14"
        stroke={stroke ? stroke : '#667085'}
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  )
}

export function DynamicPricingSmallIcon({ stroke }: IconProps) {
  return (
    <svg
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M22 7L14.1314 14.8686C13.7354 15.2646 13.5373 15.4627 13.309 15.5368C13.1082 15.6021 12.8918 15.6021 12.691 15.5368C12.4627 15.4627 12.2646 15.2646 11.8686 14.8686L9.13137 12.1314C8.73535 11.7354 8.53735 11.5373 8.30902 11.4632C8.10817 11.3979 7.89183 11.3979 7.69098 11.4632C7.46265 11.5373 7.26465 11.7354 6.86863 12.1314L2 17M22 7H15M22 7V14"
        stroke={stroke ? stroke : '#667085'}
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  )
}

export function ReportsIcon({ stroke }: IconProps) {
  return (
    <svg
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M21 21H6.2C5.07989 21 4.51984 21 4.09202 20.782C3.71569 20.5903 3.40973 20.2843 3.21799 19.908C3 19.4802 3 18.9201 3 17.8V3M7 14.5V17.5M11.5 11.5V17.5M16 8.5V17.5M20.5 5.5V17.5"
        stroke={stroke ? stroke : '#667085'}
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  )
}

export function ReportsSmallIcon({ stroke }: IconProps) {
  return (
    <svg
      width="48"
      height="48"
      viewBox="0 0 48 48"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <rect width="48" height="48" rx="6" fill="none" />
      <path
        d="M33 33H18.2C17.0799 33 16.5198 33 16.092 32.782C15.7157 32.5903 15.4097 32.2843 15.218 31.908C15 31.4802 15 30.9201 15 29.8V15M19 26.5V29.5M23.5 23.5V29.5M28 20.5V29.5M32.5 17.5V29.5"
        stroke={stroke ? stroke : '#667085'}
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  )
}

export function SettingsIcon({ stroke }: IconProps) {
  return (
    <svg
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M12 15C13.6569 15 15 13.6569 15 12C15 10.3431 13.6569 9 12 9C10.3431 9 9 10.3431 9 12C9 13.6569 10.3431 15 12 15Z"
        stroke={stroke ? stroke : '#667085'}
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M18.7273 14.7273C18.6063 15.0015 18.5702 15.3056 18.6236 15.6005C18.6771 15.8954 18.8177 16.1676 19.0273 16.3818L19.0818 16.4364C19.2509 16.6052 19.385 16.8057 19.4765 17.0265C19.568 17.2472 19.6151 17.4838 19.6151 17.7227C19.6151 17.9617 19.568 18.1983 19.4765 18.419C19.385 18.6397 19.2509 18.8402 19.0818 19.0091C18.913 19.1781 18.7124 19.3122 18.4917 19.4037C18.271 19.4952 18.0344 19.5423 17.7955 19.5423C17.5565 19.5423 17.3199 19.4952 17.0992 19.4037C16.8785 19.3122 16.678 19.1781 16.5091 19.0091L16.4545 18.9545C16.2403 18.745 15.9682 18.6044 15.6733 18.5509C15.3784 18.4974 15.0742 18.5335 14.8 18.6545C14.5311 18.7698 14.3018 18.9611 14.1403 19.205C13.9788 19.4489 13.8921 19.7347 13.8909 20.0273V20.1818C13.8909 20.664 13.6994 21.1265 13.3584 21.4675C13.0174 21.8084 12.5549 22 12.0727 22C11.5905 22 11.1281 21.8084 10.7871 21.4675C10.4461 21.1265 10.2545 20.664 10.2545 20.1818V20.1C10.2475 19.7991 10.1501 19.5073 9.97501 19.2625C9.79991 19.0176 9.55521 18.8312 9.27273 18.7273C8.99853 18.6063 8.69437 18.5702 8.39947 18.6236C8.10456 18.6771 7.83244 18.8177 7.61818 19.0273L7.56364 19.0818C7.39478 19.2509 7.19425 19.385 6.97353 19.4765C6.7528 19.568 6.51621 19.6151 6.27727 19.6151C6.03834 19.6151 5.80174 19.568 5.58102 19.4765C5.36029 19.385 5.15977 19.2509 4.99091 19.0818C4.82186 18.913 4.68775 18.7124 4.59626 18.4917C4.50476 18.271 4.45766 18.0344 4.45766 17.7955C4.45766 17.5565 4.50476 17.3199 4.59626 17.0992C4.68775 16.8785 4.82186 16.678 4.99091 16.5091L5.04545 16.4545C5.25503 16.2403 5.39562 15.9682 5.4491 15.6733C5.50257 15.3784 5.46647 15.0742 5.34545 14.8C5.23022 14.5311 5.03887 14.3018 4.79497 14.1403C4.55107 13.9788 4.26526 13.8921 3.97273 13.8909H3.81818C3.33597 13.8909 2.87351 13.6994 2.53253 13.3584C2.19156 13.0174 2 12.5549 2 12.0727C2 11.5905 2.19156 11.1281 2.53253 10.7871C2.87351 10.4461 3.33597 10.2545 3.81818 10.2545H3.9C4.2009 10.2475 4.49273 10.1501 4.73754 9.97501C4.98236 9.79991 5.16883 9.55521 5.27273 9.27273C5.39374 8.99853 5.42984 8.69437 5.37637 8.39947C5.3229 8.10456 5.18231 7.83244 4.97273 7.61818L4.91818 7.56364C4.74913 7.39478 4.61503 7.19425 4.52353 6.97353C4.43203 6.7528 4.38493 6.51621 4.38493 6.27727C4.38493 6.03834 4.43203 5.80174 4.52353 5.58102C4.61503 5.36029 4.74913 5.15977 4.91818 4.99091C5.08704 4.82186 5.28757 4.68775 5.50829 4.59626C5.72901 4.50476 5.96561 4.45766 6.20455 4.45766C6.44348 4.45766 6.68008 4.50476 6.9008 4.59626C7.12152 4.68775 7.32205 4.82186 7.49091 4.99091L7.54545 5.04545C7.75971 5.25503 8.03183 5.39562 8.32674 5.4491C8.62164 5.50257 8.9258 5.46647 9.2 5.34545H9.27273C9.54161 5.23022 9.77093 5.03887 9.93245 4.79497C10.094 4.55107 10.1807 4.26526 10.1818 3.97273V3.81818C10.1818 3.33597 10.3734 2.87351 10.7144 2.53253C11.0553 2.19156 11.5178 2 12 2C12.4822 2 12.9447 2.19156 13.2856 2.53253C13.6266 2.87351 13.8182 3.33597 13.8182 3.81818V3.9C13.8193 4.19253 13.906 4.47834 14.0676 4.72224C14.2291 4.96614 14.4584 5.15749 14.7273 5.27273C15.0015 5.39374 15.3056 5.42984 15.6005 5.37637C15.8954 5.3229 16.1676 5.18231 16.3818 4.97273L16.4364 4.91818C16.6052 4.74913 16.8057 4.61503 17.0265 4.52353C17.2472 4.43203 17.4838 4.38493 17.7227 4.38493C17.9617 4.38493 18.1983 4.43203 18.419 4.52353C18.6397 4.61503 18.8402 4.74913 19.0091 4.91818C19.1781 5.08704 19.3122 5.28757 19.4037 5.50829C19.4952 5.72901 19.5423 5.96561 19.5423 6.20455C19.5423 6.44348 19.4952 6.68008 19.4037 6.9008C19.3122 7.12152 19.1781 7.32205 19.0091 7.49091L18.9545 7.54545C18.745 7.75971 18.6044 8.03183 18.5509 8.32674C18.4974 8.62164 18.5335 8.9258 18.6545 9.2V9.27273C18.7698 9.54161 18.9611 9.77093 19.205 9.93245C19.4489 10.094 19.7347 10.1807 20.0273 10.1818H20.1818C20.664 10.1818 21.1265 10.3734 21.4675 10.7144C21.8084 11.0553 22 11.5178 22 12C22 12.4822 21.8084 12.9447 21.4675 13.2856C21.1265 13.6266 20.664 13.8182 20.1818 13.8182H20.1C19.8075 13.8193 19.5217 13.906 19.2778 14.0676C19.0339 14.2291 18.8425 14.4584 18.7273 14.7273Z"
        stroke={stroke ? stroke : '#667085'}
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  )
}

export function SettingsSmallIcon({ stroke }: IconProps) {
  return (
    <svg
      width="48"
      height="48"
      viewBox="0 0 48 48"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <rect width="48" height="48" rx="6" fill="none" />
      <path
        d="M24 27C25.6569 27 27 25.6569 27 24C27 22.3431 25.6569 21 24 21C22.3431 21 21 22.3431 21 24C21 25.6569 22.3431 27 24 27Z"
        stroke={stroke ? stroke : '#667085'}
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M30.7273 26.7273C30.6063 27.0015 30.5702 27.3056 30.6236 27.6005C30.6771 27.8954 30.8177 28.1676 31.0273 28.3818L31.0818 28.4364C31.2509 28.6052 31.385 28.8057 31.4765 29.0265C31.568 29.2472 31.6151 29.4838 31.6151 29.7227C31.6151 29.9617 31.568 30.1983 31.4765 30.419C31.385 30.6397 31.2509 30.8402 31.0818 31.0091C30.913 31.1781 30.7124 31.3122 30.4917 31.4037C30.271 31.4952 30.0344 31.5423 29.7955 31.5423C29.5565 31.5423 29.3199 31.4952 29.0992 31.4037C28.8785 31.3122 28.678 31.1781 28.5091 31.0091L28.4545 30.9545C28.2403 30.745 27.9682 30.6044 27.6733 30.5509C27.3784 30.4974 27.0742 30.5335 26.8 30.6545C26.5311 30.7698 26.3018 30.9611 26.1403 31.205C25.9788 31.4489 25.8921 31.7347 25.8909 32.0273V32.1818C25.8909 32.664 25.6994 33.1265 25.3584 33.4675C25.0174 33.8084 24.5549 34 24.0727 34C23.5905 34 23.1281 33.8084 22.7871 33.4675C22.4461 33.1265 22.2545 32.664 22.2545 32.1818V32.1C22.2475 31.7991 22.1501 31.5073 21.975 31.2625C21.7999 31.0176 21.5552 30.8312 21.2727 30.7273C20.9985 30.6063 20.6944 30.5702 20.3995 30.6236C20.1046 30.6771 19.8324 30.8177 19.6182 31.0273L19.5636 31.0818C19.3948 31.2509 19.1943 31.385 18.9735 31.4765C18.7528 31.568 18.5162 31.6151 18.2773 31.6151C18.0383 31.6151 17.8017 31.568 17.581 31.4765C17.3603 31.385 17.1598 31.2509 16.9909 31.0818C16.8219 30.913 16.6878 30.7124 16.5963 30.4917C16.5048 30.271 16.4577 30.0344 16.4577 29.7955C16.4577 29.5565 16.5048 29.3199 16.5963 29.0992C16.6878 28.8785 16.8219 28.678 16.9909 28.5091L17.0455 28.4545C17.255 28.2403 17.3956 27.9682 17.4491 27.6733C17.5026 27.3784 17.4665 27.0742 17.3455 26.8C17.2302 26.5311 17.0389 26.3018 16.795 26.1403C16.5511 25.9788 16.2653 25.8921 15.9727 25.8909H15.8182C15.336 25.8909 14.8735 25.6994 14.5325 25.3584C14.1916 25.0174 14 24.5549 14 24.0727C14 23.5905 14.1916 23.1281 14.5325 22.7871C14.8735 22.4461 15.336 22.2545 15.8182 22.2545H15.9C16.2009 22.2475 16.4927 22.1501 16.7375 21.975C16.9824 21.7999 17.1688 21.5552 17.2727 21.2727C17.3937 20.9985 17.4298 20.6944 17.3764 20.3995C17.3229 20.1046 17.1823 19.8324 16.9727 19.6182L16.9182 19.5636C16.7491 19.3948 16.615 19.1943 16.5235 18.9735C16.432 18.7528 16.3849 18.5162 16.3849 18.2773C16.3849 18.0383 16.432 17.8017 16.5235 17.581C16.615 17.3603 16.7491 17.1598 16.9182 16.9909C17.087 16.8219 17.2876 16.6878 17.5083 16.5963C17.729 16.5048 17.9656 16.4577 18.2045 16.4577C18.4435 16.4577 18.6801 16.5048 18.9008 16.5963C19.1215 16.6878 19.322 16.8219 19.4909 16.9909L19.5455 17.0455C19.7597 17.255 20.0318 17.3956 20.3267 17.4491C20.6216 17.5026 20.9258 17.4665 21.2 17.3455H21.2727C21.5416 17.2302 21.7709 17.0389 21.9324 16.795C22.094 16.5511 22.1807 16.2653 22.1818 15.9727V15.8182C22.1818 15.336 22.3734 14.8735 22.7144 14.5325C23.0553 14.1916 23.5178 14 24 14C24.4822 14 24.9447 14.1916 25.2856 14.5325C25.6266 14.8735 25.8182 15.336 25.8182 15.8182V15.9C25.8193 16.1925 25.906 16.4783 26.0676 16.7222C26.2291 16.9661 26.4584 17.1575 26.7273 17.2727C27.0015 17.3937 27.3056 17.4298 27.6005 17.3764C27.8954 17.3229 28.1676 17.1823 28.3818 16.9727L28.4364 16.9182C28.6052 16.7491 28.8057 16.615 29.0265 16.5235C29.2472 16.432 29.4838 16.3849 29.7227 16.3849C29.9617 16.3849 30.1983 16.432 30.419 16.5235C30.6397 16.615 30.8402 16.7491 31.0091 16.9182C31.1781 17.087 31.3122 17.2876 31.4037 17.5083C31.4952 17.729 31.5423 17.9656 31.5423 18.2045C31.5423 18.4435 31.4952 18.6801 31.4037 18.9008C31.3122 19.1215 31.1781 19.322 31.0091 19.4909L30.9545 19.5455C30.745 19.7597 30.6044 20.0318 30.5509 20.3267C30.4974 20.6216 30.5335 20.9258 30.6545 21.2V21.2727C30.7698 21.5416 30.9611 21.7709 31.205 21.9324C31.4489 22.094 31.7347 22.1807 32.0273 22.1818H32.1818C32.664 22.1818 33.1265 22.3734 33.4675 22.7144C33.8084 23.0553 34 23.5178 34 24C34 24.4822 33.8084 24.9447 33.4675 25.2856C33.1265 25.6266 32.664 25.8182 32.1818 25.8182H32.1C31.8075 25.8193 31.5217 25.906 31.2778 26.0676C31.0339 26.2291 30.8425 26.4584 30.7273 26.7273Z"
        stroke={stroke ? stroke : '#667085'}
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  )
}

export function UrlDashboardIcon({ stroke }: IconProps) {
  return (
    <svg
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M12 12L21 12M12 3L12 21M7.8 3H16.2C17.8802 3 18.7202 3 19.362 3.32698C19.9265 3.6146 20.3854 4.07354 20.673 4.63803C21 5.27976 21 6.11984 21 7.8V16.2C21 17.8802 21 18.7202 20.673 19.362C20.3854 19.9265 19.9265 20.3854 19.362 20.673C18.7202 21 17.8802 21 16.2 21H7.8C6.11984 21 5.27976 21 4.63803 20.673C4.07354 20.3854 3.6146 19.9265 3.32698 19.362C3 18.7202 3 17.8802 3 16.2V7.8C3 6.11984 3 5.27976 3.32698 4.63803C3.6146 4.07354 4.07354 3.6146 4.63803 3.32698C5.27976 3 6.11984 3 7.8 3Z"
        stroke={stroke ? stroke : '#667085'}
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  )
}

export function UrlDashboardSmallIcon({ stroke }: IconProps) {
  return (
    <svg
      width="48"
      height="48"
      viewBox="0 0 48 48"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <rect width="48" height="48" rx="6" fill="none" />
      <path
        d="M24 24L33 24M24 15L24 33M19.8 15H28.2C29.8802 15 30.7202 15 31.362 15.327C31.9265 15.6146 32.3854 16.0735 32.673 16.638C33 17.2798 33 18.1198 33 19.8V28.2C33 29.8802 33 30.7202 32.673 31.362C32.3854 31.9265 31.9265 32.3854 31.362 32.673C30.7202 33 29.8802 33 28.2 33H19.8C18.1198 33 17.2798 33 16.638 32.673C16.0735 32.3854 15.6146 31.9265 15.327 31.362C15 30.7202 15 29.8802 15 28.2V19.8C15 18.1198 15 17.2798 15.327 16.638C15.6146 16.0735 16.0735 15.6146 16.638 15.327C17.2798 15 18.1198 15 19.8 15Z"
        stroke={stroke ? stroke : '#667085'}
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  )
}

export function BillingIcon({ stroke }: IconProps) {
  return (
    <svg
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M22 10H2M2 8.2L2 15.8C2 16.9201 2 17.4802 2.21799 17.908C2.40973 18.2843 2.71569 18.5903 3.09202 18.782C3.51984 19 4.07989 19 5.2 19L18.8 19C19.9201 19 20.4802 19 20.908 18.782C21.2843 18.5903 21.5903 18.2843 21.782 17.908C22 17.4802 22 16.9201 22 15.8V8.2C22 7.0799 22 6.51984 21.782 6.09202C21.5903 5.7157 21.2843 5.40974 20.908 5.21799C20.4802 5 19.9201 5 18.8 5L5.2 5C4.0799 5 3.51984 5 3.09202 5.21799C2.7157 5.40973 2.40973 5.71569 2.21799 6.09202C2 6.51984 2 7.07989 2 8.2Z"
        stroke={stroke ? stroke : '#667085'}
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  )
}

export function BillingSmallIcon({ stroke }: IconProps) {
  return (
    <svg
      width="48"
      height="48"
      viewBox="0 0 48 48"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <rect width="48" height="48" rx="6" fill="none" />
      <path
        d="M34 22H14M14 20.2L14 27.8C14 28.9201 14 29.4802 14.218 29.908C14.4097 30.2843 14.7157 30.5903 15.092 30.782C15.5198 31 16.0799 31 17.2 31L30.8 31C31.9201 31 32.4802 31 32.908 30.782C33.2843 30.5903 33.5903 30.2843 33.782 29.908C34 29.4802 34 28.9201 34 27.8V20.2C34 19.0799 34 18.5198 33.782 18.092C33.5903 17.7157 33.2843 17.4097 32.908 17.218C32.4802 17 31.9201 17 30.8 17L17.2 17C16.0799 17 15.5198 17 15.092 17.218C14.7157 17.4097 14.4097 17.7157 14.218 18.092C14 18.5198 14 19.0799 14 20.2Z"
        stroke={stroke ? stroke : '#667085'}
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  )
}
